var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveSubAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 22.75H9.00014C7.68014 22.75 6.58015 22.62 5.65015 22.34C5.31015 22.24 5.09015 21.91 5.11015 21.56C5.36015 18.57 8.39015 16.22 12.0001 16.22C15.6101 16.22 18.6301 18.56 18.8901 21.56C18.9201 21.92 18.7001 22.24 18.3501 22.34C17.4201 22.62 16.3201 22.75 15.0001 22.75ZM6.72015 21.06C7.38015 21.19 8.13015 21.25 9.00014 21.25H15.0001C15.8701 21.25 16.6201 21.19 17.2801 21.06C16.7501 19.14 14.5601 17.72 12.0001 17.72C9.44015 17.72 7.25015 19.14 6.72015 21.06Z",
    fill: "#4A57DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H9C4 2 2 4 2 9V15C2 18.78 3.14 20.85 5.86 21.62C6.08 19.02 8.75 16.97 12 16.97C15.25 16.97 17.92 19.02 18.14 21.62C20.86 20.85 22 18.78 22 15V9C22 4 20 2 15 2ZM12 14.17C10.02 14.17 8.42 12.56 8.42 10.58C8.42 8.60002 10.02 7 12 7C13.98 7 15.58 8.60002 15.58 10.58C15.58 12.56 13.98 14.17 12 14.17Z",
    stroke: "#4A57DA",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 14.92C9.60992 14.92 7.66992 12.97 7.66992 10.58C7.66992 8.19002 9.60992 6.25 11.9999 6.25C14.3899 6.25 16.3299 8.19002 16.3299 10.58C16.3299 12.97 14.3899 14.92 11.9999 14.92ZM11.9999 7.75C10.4399 7.75 9.16992 9.02002 9.16992 10.58C9.16992 12.15 10.4399 13.42 11.9999 13.42C13.5599 13.42 14.8299 12.15 14.8299 10.58C14.8299 9.02002 13.5599 7.75 11.9999 7.75Z",
    fill: "#4A57DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSubAdmin);
export default __webpack_public_path__ + "static/media/ActiveSubAdmin.3a46bcfd1fddea5c26a5ae359432e544.svg";
export { ForwardRef as ReactComponent };